/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_SELECTED_INDEX_ONEPASS_AND_RECORDING_OPTIONS =
    'SET_SELECTED_INDEX_ONEPASS_AND_RECORDING_OPTIONS';
export const SET_GHOST_INDEX_ONEPASS_AND_RECORDING_OPTIONS =
    'SET_GHOST_INDEX_ONEPASS_AND_RECORDING_OPTIONS';

export const SET_ONEPASS_AND_RECORDING_OPTIONS = 'SET_ONEPASS_AND_RECORDING_OPTIONS';

export const SET_ONEPASS_AND_RECORDING_ERROR = 'SET_ONEPASS_AND_RECORDING_ERROR';

export const SET_ONEPASS_AND_RECORDING_OR_MY_SHOWS_OPTIONS_GET_ERROR =
    'SET_ONEPASS_AND_RECORDING_OR_MY_SHOWS_OPTIONS_GET_ERROR';
